export function driveToFileEntryModel(drive) {
  return {
    name: drive.name,
    type: drive.locationType,
    path: drive.physicalPath
  };
}

export function entryToFileEntryModel(entry) {
  return {
    name:         entry.name,
    type:         entry.type === 'File' ? 'file' : 'folder',
    path:         entry.physicalPath,
    lastModified: new Date(entry.lastModified),
    length:       entry.length
  }
}